"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBitcoinJsLibNetwork = exports.BitcoinNetwork = void 0;
const bitcoinjs_lib_1 = require("bitcoinjs-lib");
/**
 * Bitcoin networks.
 */
var BitcoinNetwork;
(function (BitcoinNetwork) {
    /* eslint-disable no-unused-vars */
    /**
     * Unknown network.
     */
    BitcoinNetwork["Unknown"] = "unknown";
    /**
     * Bitcoin Testnet.
     */
    BitcoinNetwork["Testnet"] = "testnet";
    /**
     * Bitcoin Mainnet.
     */
    BitcoinNetwork["Mainnet"] = "mainnet";
    /* eslint-enable no-unused-vars */
})(BitcoinNetwork = exports.BitcoinNetwork || (exports.BitcoinNetwork = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (BitcoinNetwork) {
    /**
     * Gets Bitcoin Network type by comparing a provided hash to known
     * {@link https://en.bitcoin.it/wiki/Genesis_block genesis block hashes}.
     * Returns {@link BitcoinNetwork.Unknown}
     * @param hash Hash of a block.
     * @returns Bitcoin Network.
     */
    function fromGenesisHash(hash) {
        switch (hash.toString()) {
            case "000000000019d6689c085ae165831e934ff763ae46a2a6c172b3f1b60a8ce26f": {
                return BitcoinNetwork.Mainnet;
            }
            case "000000000933ea01ad0ee984209779baaec3ced90fa3f408719526f8d77f4943": {
                return BitcoinNetwork.Testnet;
            }
            default: {
                return BitcoinNetwork.Unknown;
            }
        }
    }
    BitcoinNetwork.fromGenesisHash = fromGenesisHash;
})(BitcoinNetwork = exports.BitcoinNetwork || (exports.BitcoinNetwork = {}));
/**
 * Converts the provided {@link BitcoinNetwork} enumeration to a format expected
 * by the `bitcoinjs-lib` library.
 * @param bitcoinNetwork - Specified Bitcoin network.
 * @returns Network representation compatible with the `bitcoinjs-lib` library.
 * @throws An error if the network is not supported by `bitcoinjs-lib`.
 */
function toBitcoinJsLibNetwork(bitcoinNetwork) {
    switch (bitcoinNetwork) {
        case BitcoinNetwork.Mainnet: {
            return bitcoinjs_lib_1.networks.bitcoin;
        }
        case BitcoinNetwork.Testnet: {
            return bitcoinjs_lib_1.networks.testnet;
        }
        default: {
            throw new Error(`network not supported`);
        }
    }
}
exports.toBitcoinJsLibNetwork = toBitcoinJsLibNetwork;
//# sourceMappingURL=network.js.map